import { classes } from 'src/modules/shared/utils/styles.util';
import { DetailsSkeletonBlock } from './details-skeleton-block';

export const DetailsRevealSkeleton = ({
  hiddenCount,
}: {
  hiddenCount: number;
}) => (
  <div className="mt-5 mb-3 flex justify-center">
    <div className="flex h-10 items-center gap-2 rounded-full border border-gray-200 bg-white px-4 shadow-sm">
      <DetailsSkeletonBlock className="h-4 w-4 rounded-full" />
      <DetailsSkeletonBlock
        className={classes('h-4 rounded', hiddenCount > 9 ? 'w-20' : 'w-16')}
      />
    </div>
  </div>
);
